<template>
	<div class="fd-split" :class="extraClasses" v-if="visible">
		<template v-for="item in sp.items">
			<component
				:is="componentOfPart(item)"
				:part="partRef(item)"
				:data="localData"
				:readonly="ro"
				:viewmode="vm"
				:style="itemStyle(item)"></component>
		</template>
	</div>
</template>

<script setup lang="ts">
import useContainer, {type ContainerProps, containerProps} from "./Container";
import {computed, type CSSProperties} from "vue";
import type {Split, SplitFormPart, SplitFormPartOrReference} from "@t/fd/layout/Split";

const uprops = defineProps({...containerProps});
const props = uprops as ContainerProps;

const sp = computed<Split>(() => props.part as Split);

const {visible, clazz, style, componentOfPart, partRef, localData, ro, vm} = useContainer(props);

const extraClasses = computed(() => {
	const c = [];
	if (sp.value.direction === "column") c.push("fd-split-vertical");
	else c.push("fd-split-horizontal");
	if (sp.value.style === "separated") c.push("fd-split-separated");
	return c;
});

function itemStyle(part: SplitFormPartOrReference): CSSProperties {
	let sp: SplitFormPart;
	if (typeof part === "string") sp = partRef(part) as SplitFormPart;
	else sp = part;
	const s: CSSProperties = {};
	if (sp.width) s.width = sp.width;
	return s;
}
</script>

<style>
.fd-split {
	display: flex;
	align-items: baseline;
}

.fd-split-vertical {
	flex-direction: column;
}

.fd-split-horizontal {
	flex-direction: row;
}

.fd-split-separated > * {
	border-left: var(--hair) solid var(--border-color) !important;
	padding-left: var(--gap) !important;
}

.fd-split-separated > *:first-child {
	border-left: none !important;
	padding-left: 0 !important;
}
</style>
